<template>
  <el-dialog
    :title="formTitle"
    :visible.sync="isVisible"
    class="dialog-company-remark-subjects-form"
    custom-class="dialog-short-form"
    :class="{'is-edit-mode': isEditMode, 'is-new': state === 'new'}"
    :closeOnClickModal="false"
    append-to-body
    @close="handleDialogClose">
    <div class="company-remark-subjects-form-content" v-loading="isLoading">
      <form-company-remark-subjects
        :data="data"
        :model="formModel"
        @updateModelItem="handlerUpdateModelItem"
        @change="handleFormData"
        ref="Form"/>
      <form-controls
        class="form-footer"
        :isBack="isAvailableToSave"
        :isCancel="!isAvailableToSave"
        :isCreate="!hasCreateNew"
        :isSave="hasCreateNew"
        :isDelete="hasCreateNew"
        @command="setCommand"/>
    </div>
  </el-dialog>
</template>

<script>
import FormWrapper from '@/components/Form/FormWrapper'
import FormWrapperAutoSave from '@/components/Form/FormWrapperAutoSave'

export default {
  name: 'ModalNewCompanyRemarkSubjects',
  mixins: [FormWrapper, FormWrapperAutoSave],
  components: {
    'form-company-remark-subjects': () => import(/* webpackChunkName: 'CompanyRemarkSubjects' */ './Form'),
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls')
  },
  props: {
    config: { type: Object }
  },
  data () {
    return {
      // eslint-disable-next-line
      apiPatch: 'CompanyRemarkSubjects/Patch/${data.id}'
    }
  },
  computed: {
    formTitle () {
      return this.formData.subject || this.checkEs6AndRun(this.title)
    }
  },
  methods: {
    formModel () {
      return {
        id: '',
        subject: '',
        tableIndex: ''
      }
    },
    handleDialogClose () {
      let command = this.isAvailableToSave ? 'back' : 'cancel'
      this.setCommand(command)
    }
  }
}
</script>

<style lang="stylus">

</style>
